export const handleEmailClick = (e, targetEmail = "info@cubegames.ca") => {
  if (e) {
    e.preventDefault();
  }
  
  const email = targetEmail;
  const userAgent = navigator.userAgent.toLowerCase();
  
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  const isEdge = /edge|edg/i.test(userAgent);
  const isFirefox = /firefox|fxios/i.test(userAgent);
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  const isChrome = /chrome|crios/i.test(userAgent) && !isEdge && !/opr|brave/i.test(userAgent);

  if (isMobile) {
    // On mobile, use the device's native email system
    window.location.href = `mailto:${email}`;
  } else if (isChrome) {
    // Chrome -> Assuming Google ecosystem, try Gmail Web
    // (If not logged in, Google will prompt them to log in)
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`, '_blank', 'noopener,noreferrer');
  } else if (isEdge) {
    // Edge -> Assuming Microsoft ecosystem, try Outlook Web
    window.open(`https://outlook.live.com/mail/0/deeplink/compose?to=${email}`, '_blank', 'noopener,noreferrer');
  } else if (isFirefox || isSafari) {
    // Firefox & Safari -> Use native email system directly
    window.location.href = `mailto:${email}`;
  } else {
    // Fallback for any other obscure browsers -> Native email system
    window.location.href = `mailto:${email}`;
  }
};
